/**
 * Canonical, ordered list of the therapist exercise "Hilfestellung" (help) keys.
 *
 * Single source of truth shared by:
 *   • HilfestellungPicker        — the multi-select UI (icons/labels live there)
 *   • therapistExerciseDraft     — the creation default (all helps on)
 *   • telemetry-events-therapist — "did the therapist narrow the default" flag
 *
 * Mirrors the backend allowlist (App\Http\Controllers\Therapist\ExerciseController
 * ::VALID_HELPS) — keep the two in lockstep.
 */
export const ALL_HELP_KEYS = [
  'semantic_1', 'semantic_2', 'semantic_3',
  'phonematic_1', 'phonematic_2', 'phonematic_3',
  'graphematic_1', 'graphematic_2', 'graphematic_3',
  'visual_mouth', 'visual_mouth_slow', 'visual_image',
] as const
